import { BOOT_LOADER_BARS } from '@sara/ui/lib/boot-loader';

/**
 * Mirrors the static boot loader injected into index.html (same mark, same
 * position, same background) so bundle-load → auth-check → app reads as one
 * continuous loading state.
 */
export function AppLoadingScreen() {
  return (
    <output className="fixed inset-0 flex flex-col items-center justify-center gap-6 bg-background">
      <div className="flex h-11 items-center gap-[5px]" aria-hidden="true">
        {BOOT_LOADER_BARS.map((bar) => (
          <span
            key={bar.delaySeconds}
            className={`w-1.5 animate-eq rounded motion-reduce:animate-none ${
              bar.accent ? 'bg-primary' : 'bg-foreground/30'
            }`}
            style={{ height: bar.height, animationDelay: `${bar.delaySeconds}s` }}
          />
        ))}
      </div>
      <div className="text-[13px] tracking-wide text-muted-foreground">Loading console…</div>
    </output>
  );
}
